<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { WizardForm } from '@/types/wizard-forms'

const props = defineProps<{
  form: WizardForm
}>()

const emit = defineEmits<{
  delete: [formId: number]
}>()

const { t } = useI18n()
</script>

<template>
  <div class="rounded-xl bg-slate-800/50 border border-slate-700 px-5 py-4 flex items-start justify-between gap-4">
    <div class="min-w-0 flex-1">
      <span class="text-white font-semibold text-sm block truncate">{{ props.form.name }}</span>
      <p v-if="props.form.description" class="text-xs text-slate-400 mt-0.5 line-clamp-2">
        {{ props.form.description }}
      </p>
      <div class="flex items-center gap-3 mt-2">
        <span class="inline-flex items-center gap-1 text-xs text-slate-500">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          {{ t('wizard_forms.list.pages_count', { count: props.form.pages_count ?? 0 }) }}
        </span>
        <span class="inline-flex items-center gap-1 text-xs text-slate-500">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          {{ t('wizard_forms.list.races_count', { count: props.form.races_count ?? 0 }) }}
        </span>
      </div>
    </div>
    <div class="flex items-center gap-2 shrink-0">
      <RouterLink
        :to="`/organizer/wizard-forms/${props.form.id}`"
        class="text-xs font-medium text-emerald-400 hover:text-emerald-300 transition-colors px-3 py-1.5 rounded-lg border border-emerald-500/30 hover:border-emerald-500/60"
      >
        {{ t('wizard_forms.list.action_edit') }}
      </RouterLink>
      <button
        type="button"
        class="text-xs font-medium text-red-400 hover:text-red-300 transition-colors px-3 py-1.5 rounded-lg border border-red-500/30 hover:border-red-500/60"
        @click="emit('delete', props.form.id)"
      >
        {{ t('common.delete') }}
      </button>
    </div>
  </div>
</template>
